import { render, staticRenderFns } from "./giveLesson-detail.vue?vue&type=template&id=4b300006&scoped=true"
import script from "./giveLesson-detail.vue?vue&type=script&lang=js"
export * from "./giveLesson-detail.vue?vue&type=script&lang=js"
import style0 from "./giveLesson-detail.vue?vue&type=style&index=0&id=4b300006&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b300006",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b300006')) {
      api.createRecord('4b300006', component.options)
    } else {
      api.reload('4b300006', component.options)
    }
    module.hot.accept("./giveLesson-detail.vue?vue&type=template&id=4b300006&scoped=true", function () {
      api.rerender('4b300006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/teacher/giveLesson-detail.vue"
export default component.exports